import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { pushNotification } from '../../components/PinnacleSnackbarProvider/PinnacleSnackbarProvider';
import { NotificationTypes } from '../../components/PinnacleSnackbarProvider/PinnacleSnackbarProvider.types';
import { ADMIN_CURRENT_NAME, ADMIN_STORAGE_KEY, CONFIRM_LOGOUT_MSG, SUCCESSFULLY_LOGGED_OUT_MSG } from '../../utils/constants';

interface LogoutDialogProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function LogoutDialog({ open, setOpen }: LogoutDialogProps) {
    const navigate = useNavigate();

    const handleClose = () => {
        setOpen(false);
    };

    const handleLogout = () => {
        setOpen(false);
        localStorage.removeItem(ADMIN_STORAGE_KEY);
        localStorage.removeItem(ADMIN_CURRENT_NAME);
        sessionStorage.removeItem(ADMIN_STORAGE_KEY);
        sessionStorage.removeItem(ADMIN_CURRENT_NAME);
        navigate('/login');
        pushNotification({
            details: SUCCESSFULLY_LOGGED_OUT_MSG,
            type: NotificationTypes.Success,
        });
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
        >
            <DialogTitle id="responsive-dialog-title">
                {"Confirm Logout"}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {CONFIRM_LOGOUT_MSG}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} sx={{ textTransform: 'none' }}>
                    No
                </Button>
                <Button onClick={handleLogout} sx={{ textTransform: 'none' }} autoFocus>
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    );
}
